import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  MDBInput,
  ModalHeader,
} from "mdbreact";
import { MDBModalTitle } from "mdb-react-ui-kit";
import ApiService from "../../../services/ApiService";
import Select from "react-select";
import Loader from "../../../common/Loader";
import { toast } from "react-toastify";
import Pagination from "../../../common/Pagination";

class GuestsEditor extends React.Component {
  constructor(props) {
    super(props);

    this.filterByText = this.filterByText.bind(this);
    this.filterByTag = this.filterByTag.bind(this);
    this.checkAll = this.checkAll.bind(this);
    this.checkOne = this.checkOne.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.filter = this.filter.bind(this);
    this.sendInvitations = this.sendInvitations.bind(this);
    this.changePage = this.changePage.bind(this);

    this.state = {
      numberPerPage: 20,
      currentPage: 0,
      totalPages: Math.ceil(this.props.contacts.length / 20),
      contactsChecked: [],
      modal: false,
      nameFilter: "",
      companyFilter: "",
      tagsFilter: "",
      contacts: this.props.contacts,
      contactsFiltered: this.props.contacts,
      tagsList: this.props.tagsList,
      companiesList: [],
      packageId:
        this.props.packagesOptions.length === 1
          ? this.props.packagesOptions[0].value
          : "",
      invitation_package_id: "",
      max_invitation: 0,
      is_followers: false,
      isLoading: this.props.contacts.length > 0 ? false : true,
      showModalCheckEmail: false,
      maxGuestsBeforeToUseJobs: 2300, // this is defined in backend too, if you want to change this, changed it in laravel too.
    };
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (
      this.props.contacts !== prevProps.contacts &&
      this.props.contacts.length !== 0
    ) {
      this.setState({
        isloading: false,
        totalPages: Math.ceil(this.props.contacts.length / 20),
        contacts: this.props.contacts,
        contactsFiltered: this.props.contacts,
      });
    }
  }

  changePage(page) {
    this.setState({ currentPage: page });
  }

  handleChange(event) {
    console.log(event);
    this.setState({ [event.target.name]: event.target.value });
  }

  filterByText(event) {
    const self = this;
    this.setState(
      {
        [event.target.name]: event.target.value,
      },
      () => {
        self.filter();
      }
    );
  }

  filterByTag(event) {
    const self = this;

    this.setState(
      {
        tagsFilter: event ? event : "",
      },
      () => {
        self.filter();
      }
    );
  }

  filter() {
    let contactsFiltered = this.props.contacts;

    if (this.state.nameFilter.length > 0) {
      contactsFiltered = contactsFiltered.filter((contact) => {
        return contact.firstname
          .toLowerCase()
          .includes(this.state.nameFilter.toLowerCase()) ||
          contact.lastname
            .toLowerCase()
            .includes(this.state.nameFilter.toLowerCase())
          ? contact
          : null;
      });
    }

    if (this.state.companyFilter.length > 0) {
      contactsFiltered = contactsFiltered.filter((contact) => {
        return contact.company
          ? contact.company.name
              .toLowerCase()
              .includes(this.state.companyFilter.toLowerCase())
          : null;
      });
    }

    if (this.state.tagsFilter.length > 0) {
      contactsFiltered = contactsFiltered.filter((contact) => {
        return contact.tags.some((tag) =>
          this.state.tagsFilter.find((tagFilter) => tagFilter.value === tag.id)
        );
      });
    }

    this.setState({
      contactsFiltered,
      totalPages: Math.ceil(contactsFiltered.length / 20),
      currentPage: 0,
    });
  }

  async sendInvitations() {
    const {
      contactsChecked,
      packageId,
      max_invitation,
      invitation_package_id,
    } = this.state;
    const self = this;
    this.setState({ isloading: true });

    const result = await ApiService.awaitRequest(
      {
        evenement_id: this.props.eventId,
        package_id: packageId,
        checked_in: false,
        report_recipient: JSON.parse(localStorage.getItem("user")).email,
        max_invitation: max_invitation,
        contact_ids: contactsChecked.map((contact) => contact.id),
        invitation_package_id: max_invitation > 0 ? invitation_package_id : "",
        is_validated: true,
        maxGuestsBeforeToUseJobs: this.state.maxGuestsBeforeToUseJobs,
      },
      "guests/create/bygroup",
      "post"
    );

    this.setState({ isloading: false }, () => {
      if (result) {
        if (contactsChecked.length > this.state.maxGuestsBeforeToUseJobs) {
          self.setState({ modal: false });
          self.setState({ showModalCheckEmail: true });
        } else {
          toast.success("Ajout des contacts en cours...");
          self.props.loadData();
        }
      } else {
        toast.error(
          "Erreur lors de l'invitation des contacts, il vous est nécessaire de recocher les contacts non invités."
        );
        self.props.loadData();
      }
    });
  }

  checkOne(event, newContact) {
    if (event.target.checked) {
      const contactsChecked = this.state.contactsChecked;
      contactsChecked.push(newContact);
      this.setState({
        contactsChecked,
      });
    } else {
      this.setState({
        contactsChecked: this.state.contactsChecked.filter(
          (contact) => contact.id !== newContact.id
        ),
      });
    }
  }

  checkAll(event) {
    if (event.target.checked) {
      this.setState({
        contactsChecked: this.state.contactsFiltered,
      });
    } else {
      this.setState({
        contactsChecked: [],
      });
    }
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  toggle2 = () => {
    this.setState({
      showModalCheckEmail: !this.state.showModalCheckEmail,
    });
  };

  render() {
    const {
      contactsFiltered,
      companyFilter,
      nameFilter,
      contactsChecked,
      packageId,
      max_invitation,
      invitation_package_id,
      currentPage,
      isloading,
      showModalCheckEmail,
    } = this.state;

    const { tagOptions, packagesOptions } = this.props;

    return (
      <div className="button-container">
        <Button className="btn pink darken-1" onClick={this.toggle}>
          {"  "} Inviter &nbsp; des &nbsp; contacts {"  "}
          {"  "}&nbsp;
        </Button>
        <Modal size="lg" isOpen={this.state.modal} toggle={this.toggle}>
          <ModalBody>
            {!isloading ? (
              <>
                <div className="col-md-12 font-weight-bold">
                  1 - Sélectionnez les contacts à inviter
                </div>

                <div className="col-md-12">
                  <div className="row" style={{ backgroundColor: "#EEEEEE" }}>
                    <div className="col-md-4">
                      <MDBInput
                        type="text"
                        value={nameFilter}
                        name="nameFilter"
                        label={"Rechercher par nom"}
                        onChange={this.filterByText}
                      />
                    </div>
                    <div className="col-md-4">
                      <MDBInput
                        type="text"
                        value={companyFilter}
                        name="companyFilter"
                        label={"Rechercher par société"}
                        onChange={this.filterByText}
                      />
                    </div>
                    <div className="col-md-4">
                      <div className="md-form">
                        <Select
                          placeholder={"Rechercher par tags"}
                          onChange={this.filterByTag}
                          options={tagOptions}
                          isMulti={true}
                        />
                      </div>
                    </div>
                  </div>
                  <table className="table table-sm table-striped">
                    <thead>
                      <tr>
                        <th scope="col">
                          <input
                            type="checkbox"
                            style={{ opacity: 1, pointerEvents: "auto" }}
                            onChange={this.checkAll}
                          />
                        </th>
                        <th scope="col">Nom</th>
                        <th scope="col">Langue</th>
                        <th scope="col">Société</th>
                        <th scope="col">Email</th>
                        <th scope="col">Tags</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contactsFiltered.map((contact, i) =>
                        i < 20 * (currentPage + 1) && i >= 20 * currentPage ? (
                          <tr key={i}>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  this.state.contactsChecked.filter(
                                    (contactChecked) =>
                                      contactChecked.id === contact.id
                                  ).length > 0
                                }
                                onChange={(e) => this.checkOne(e, contact)}
                                style={{ opacity: 1, pointerEvents: "auto" }}
                              />
                            </td>
                            <td>
                              {contact.firstname + " " + contact.lastname}
                            </td>
                            <td>{contact.languages}</td>
                            <td>
                              {contact.company ? contact.company.name : null}
                            </td>
                            <td>{contact.mail}</td>
                            <td>
                              {contact.tags.map((tag) => tag.tag_name + ", ")}
                            </td>
                          </tr>
                        ) : null
                      )}
                    </tbody>
                  </table>
                  <div className="row" style={{ listStyleType: "none" }}>
                    <div className="row  pl-4 pr-4  pagination">
                      <Pagination
                        changePage={this.changePage}
                        currentPage={currentPage}
                        totalPages={this.state.totalPages}
                      />
                    </div>
                  </div>
                  {contactsChecked.length > 0 ? (
                    <div className="row mr-0 ml-0 actions-container">
                      <div className="col-md-4">
                        <div className="form-group">
                          <div className="font-weight-bold">
                            2- Paramétrage de l'invitation
                          </div>

                          <label>
                            {contactsChecked.length} contact
                            {contactsChecked.length > 1 ? "s" : null}
                            sélectionné
                            {contactsChecked.length > 1 ? "s" : null}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <select
                            onChange={this.handleChange}
                            name="packageId"
                            className="col-sm-12 browser-default custom-select"
                            value={packageId}
                            required
                          >
                            <option value={null}>Package invité</option>
                            {packagesOptions.map((option) => (
                              <option value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="form-group">
                          <MDBInput
                            label={"Nombre d'invitations"}
                            name="max_invitation"
                            value={max_invitation}
                            onChange={this.handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        {max_invitation > 0 && (
                          <div className="form-group">
                            <select
                              onChange={this.handleChange}
                              name="invitation_package_id"
                              className="col-sm-12 browser-default custom-select"
                              value={invitation_package_id}
                              required
                            >
                              <option value="">Package accompagnant</option>
                              {packagesOptions.map((option) => (
                                <option value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                        <div className="form-group">
                          <Button
                            className="btn btn-block  pink darken-1"
                            disabled={
                              contactsChecked.length === 0 ||
                              packageId.length === 0 ||
                              max_invitation.length === 0
                            }
                            onClick={this.sendInvitations}
                          >
                            Valider
                          </Button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </>
            ) : (
              <Loader />
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              className="btn btn-block  pink darken-1"
              onClick={this.toggle}
            >
              Fermer
            </Button>
          </ModalFooter>
        </Modal>

        {showModalCheckEmail && (
          <Modal
            isOpen={showModalCheckEmail}
            size="lg"
            toggle={this.toggle2}
            tabIndex="-1"
          >
            <ModalHeader>
              <MDBModalTitle>Ajout des invités</MDBModalTitle>
            </ModalHeader>
            <ModalBody>
              <div class="alert alert-warning text-center" role="alert">
                Vos invités sont en cours d'ajout. Vous recevrez un email
                lorsque l'opération sera terminée.
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                className="btn pink darken-1"
                onClick={() => {
                  this.setState({ showModalCheckEmail: false });
                  this.props.loadData();
                }}
              >
                Fermer
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </div>
    );
  }
}

export default GuestsEditor;
